import { Link } from "react-router-dom";
import styled, { css } from 'styled-components/macro'
import CenterFooterContent from "../CenterFooterContent";
import LeftFooterContent from "../LeftFooterContent";
import RightFooterContent from "../RightFooterContent";
import FixedFooter from "./FixedFooter";


const style = css`
  color: rgba(${p => p.theme.color.light}, 1);
  white-space: nowrap;
  overflow: hidden;
  flex-shrink: 0;
  text-overflow: ellipsis;
  text-decoration: none;

  &:last-child {
    flex-shrink: 1;
  }

  &:hover, &:focus {
    outline: none;
    text-decoration: underline;
  }

  &::before {
    content: '|';
    padding: 0 calc(${p => p.theme.spacing} * .5);
  }
  &:first-child::before {
    content: "";
  }
`;

const StyledLink = styled(Link)`
  ${style}
`;

const StyledA = styled.a`
  ${style}
`;

const scrollToBottom = event => {
  event.preventDefault();
  window.scrollTo(0, document.body.scrollHeight);
}

export default () => (
  <FixedFooter>
    <LeftFooterContent />
    <CenterFooterContent>
      <StyledLink to="/disclaimer">Disclaimer</StyledLink>
      <StyledA href="" onClick={scrollToBottom}>Impressum</StyledA>
      <StyledLink to="/contact">Kontakt</StyledLink>
    </CenterFooterContent>
    <RightFooterContent />
  </FixedFooter>
);
